<template>
  <div class="fixed bottom-0 pb-5 pl-5 sm:pb-12 sm:pl-12">
    <div
      v-if="show"
      class="flex items-center py-3 pl-3 pr-4 text-white bg-gray-900 rounded-full"
    >
      <svg
        v-if="internalIcon === 'delete'"
        width="16"
        height="16"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-test="icon-delete"
        class="mr-3"
      >
        <path
          d="M10.6667 0C12.0868 0 13.2477 1.11015 13.3288 2.50998L13.3333 2.66667L13.3332 3.55544L16.8889 3.55556C17.3389 3.55556 17.7108 3.88996 17.7697 4.32383L17.7778 4.44444C17.7778 4.93536 17.3798 5.33333 16.8889 5.33333L15.9989 5.33256L16 16.8889C16 18.3091 14.8898 19.4699 13.49 19.551L13.3333 19.5556H4.44444C3.02428 19.5556 1.86341 18.4454 1.7823 17.0456L1.77778 16.8889L1.77711 5.33256L0.888889 5.33333C0.438879 5.33333 0.0669738 4.99893 0.00811463 4.56506L0 4.44444C0 3.95352 0.397969 3.55556 0.888889 3.55556L4.444 3.55544L4.44444 2.66667C4.44444 1.24651 5.5546 0.0856348 6.95442 0.00452691L7.11111 0H10.6667ZM14.2218 5.33256H3.55544L3.55556 16.8889C3.55556 17.3447 3.8987 17.7205 4.34078 17.7718L4.44444 17.7778H13.3333C13.7892 17.7778 14.1649 17.4346 14.2162 16.9926L14.2222 16.8889L14.2218 5.33256ZM10.6667 8C11.1576 8 11.5556 8.39797 11.5556 8.88889V14.2222C11.5556 14.7131 11.1576 15.1111 10.6667 15.1111C10.1757 15.1111 9.77778 14.7131 9.77778 14.2222V8.88889C9.77778 8.39797 10.1757 8 10.6667 8ZM7.11111 8C7.60203 8 8 8.39797 8 8.88889V14.2222C8 14.7131 7.60203 15.1111 7.11111 15.1111C6.62019 15.1111 6.22222 14.7131 6.22222 14.2222V8.88889C6.22222 8.39797 6.62019 8 7.11111 8ZM10.6667 1.77778H7.11111C6.65526 1.77778 6.27955 2.12092 6.2282 2.563L6.22222 2.66667L6.22111 3.55544H11.5549L11.5556 2.66667C11.5556 2.21081 11.2124 1.8351 10.7703 1.78376L10.6667 1.77778Z"
          fill="#F5F5F5"
        />
      </svg>
      <p class="text-sm leading-6">{{ internalTitle }}</p>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { EventBus } from "../eventBus";

export default Vue.extend({
  props: {
    title: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "delete",
      validator(val) {
        return ["delete"].includes(val);
      }
    },
    duration: {
      type: Number,
      default: 5000
    }
  },
  data() {
    return {
      internalDuration: this.duration,
      internalIcon: this.icon,
      internalTitle: this.title,
      show: false,
      timer: null
    };
  },
  mounted() {
    EventBus.$on("show", ({ title, icon }) => {
      clearTimeout(this.timer);
      this.show = true;
      this.internalTitle = title;
      this.internalIcon = icon;

      this.timer = setTimeout(() => {
        this.show = false;
      }, this.internalDuration);
    });
  }
});
</script>
